import { Link } from 'react-router-dom';
import SectionTitle from '@/components/feature/SectionTitle';
import { plotArcs } from '@/mocks/manga';

export default function PlotPreview() {
  const arcs = plotArcs.slice(0, 3);
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6 lg:px-8">
        <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
          <SectionTitle
            kicker="剧情主线"
            title="故事是怎么一步步展开的"
            desc="按幕梳理《泡在我家的辣妹》的剧情脉络，从相遇同住到心动告白，轻松掌握整体走向。"
          />
          <Link
            to="/plot"
            className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-primary-300 px-4 py-2 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-100"
          >
            查看完整主线
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
          {arcs.map((arc, idx) => (
            <article key={arc.id} className="flex flex-col overflow-hidden rounded-lg bg-background-50">
              <div className="relative">
                <img
                  src={arc.image}
                  alt={`泡在我家的辣妹剧情主线${arc.step}：${arc.title}`}
                  className="h-40 w-full object-cover object-top"
                />
                <span className="absolute left-3 top-3 rounded-md bg-primary-500 px-2.5 py-1 text-xs font-medium text-background-50">
                  {arc.step}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h3 className="font-heading text-lg text-foreground-900">{arc.title}</h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{arc.summary}</p>
                <p className="mt-3 inline-flex items-center gap-1.5 text-xs font-medium text-accent-700">
                  <i className="ri-sparkling-2-line"></i>
                  第 {idx + 1} 幕 · 点击查看详情
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}